import { StorageService } from './storage.service';
import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { UtilitiesService } from './utilities.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  private allJobs: any[] = [];

  constructor(
    private storage: StorageService,
    private api: RestService,
    private utilities: UtilitiesService
  ) {}

  async get(user: string, url: string) {
    const key: string = user + '_' + url;
    return this.storage.get(key);
  }

  async store(user: string, url: string, value: any) {
    const key: string = user + '_' + url;

    return this.storage.store(key, value);
  }

  getVisitsPlan(date: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.get(this.api.getUsername(), 'schedule/' + date)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getEljakimVisitsPlan(date: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.get(this.api.getUsername(), 'eljakim_schedule/' + date)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getNonVisitsPlan(date: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.get(this.api.getUsername(), 'non_visits_schedule/' + date)
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getVisitResults(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.get(this.api.getUsername(), 'visitResults')
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getQuestionnaire(
    id: number,
    parentObject: string,
    customFormId: number
  ): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.get(
        this.api.getUsername(),
        'questionnaire/' + customFormId + '/' + parentObject + '/' + id
      )
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  clearLocalStorage() {
    this.storage.clear();
  }
}
